export default class HeroSlider {
    constructor () {
        this.image = document.querySelector('#hero-slider-image')
        this.spinner = document.querySelector('#hero-slider-loading-spinner')
        this.isLoaded = false //防止重复加载
        if (this.image && this.spinner) {
            this.init()
        }
    }
    //init
    init () {
        //监听图片的load事件
        this.image.addEventListener('load', () => this.handleImageLoad())
        //如果图片已经加载完毕，直接执行
        if(this.image.complete) this.handleImageLoad()
    }
    handleImageLoad () {
        if (this.isLoaded) return //防止重复加载
        this.isLoaded = true
        this.addClassToImage()
        this.disableSpinner()
    }
    //method
    disableSpinner () {
        this.spinner.style.display = 'none'
    }
    addClassToImage () {
        this.image.classList.add('hero-slider-image')
    }
}
